import React, { useMemo } from 'react';
import {
  FormControl,
  TextField,
  Autocomplete,
} from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { pracaService } from '../../services/praca';

interface SelectPracaProps {
  value: number;
  onChange: (value: number) => void;
  label?: string;
  required?: boolean;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  idFuncionario?: number;
}

const SelectPraca: React.FC<SelectPracaProps> = ({
  value,
  onChange,
  label = 'Praça',
  required = false,
  error = false,
  helperText,
  disabled = false,
  fullWidth = true,
  idFuncionario,
}) => {
  const { data: pracas = [], isLoading } = useQuery({
    queryKey: ['pracas', idFuncionario],
    queryFn: () =>
      idFuncionario && idFuncionario > 0
        ? pracaService.getByIdFuncionario(idFuncionario)
        : pracaService.getAll(),
    staleTime: 5 * 60 * 1000,
  });

  const sortedPracas = useMemo(
    () =>
      [...pracas].sort((a, b) =>
        a.nomePraca.localeCompare(b.nomePraca, 'pt-BR', { sensitivity: 'base' })
      ),
    [pracas]
  );

  const selected = useMemo(
    () => sortedPracas.find((p) => p.id === value) || null,
    [sortedPracas, value]
  );

  return (
    <FormControl
      fullWidth={fullWidth}
      required={required}
      error={error}
      disabled={disabled}
    >
      <Autocomplete
        options={sortedPracas}
        getOptionLabel={(p) => p.nomePraca}
        isOptionEqualToValue={(a, b) => a.id === b.id}
        value={selected}
        onChange={(_, newValue) => onChange(newValue?.id || 0)}
        disabled={disabled}
        loading={isLoading}
        loadingText="Carregando..."
        noOptionsText="Nenhuma praça encontrada"
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            required={required}
            error={error}
            helperText={helperText}
          />
        )}
      />
    </FormControl>
  );
};

export default SelectPraca;
